import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import SubscriptionContext from 'src/context/subscription';
import { useParamsQuery } from 'src/hooks/useQuery';
import { storeSubscription } from 'src/storage/subscription';

const removeBootstrapParamsFromUrl = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const cleanQuery = new URLSearchParams(window.location.search);
  cleanQuery.delete('subscriptionId');
  cleanQuery.delete('token');

  const cleanSearch = cleanQuery.toString();
  const cleanUrl = `${window.location.pathname}${
    cleanSearch ? `?${cleanSearch}` : ''
  }${window.location.hash}`;

  window.history.replaceState({}, document.title, cleanUrl);
};

const ResupplyModelV3Layout = ({ children }) => {
  const query = useParamsQuery();
  const subscriptionId = query.get('subscriptionId');

  const { subscriptionContext, setSubscriptionContext } =
    useContext(SubscriptionContext);

  useEffect(() => {
    if (!subscriptionId) {
      return;
    }

    const nextSubId = subscriptionId || subscriptionContext.subId;

    setSubscriptionContext((previousContext) => ({
      ...previousContext,
      subId: nextSubId,
    }));

    storeSubscription({
      subId: nextSubId,
      token: subscriptionContext.token,
    });

    removeBootstrapParamsFromUrl();
  }, [
    subscriptionId,
    subscriptionContext.subId,
    subscriptionContext.token,
    setSubscriptionContext,
  ]);

  const currentSubId = String(subscriptionContext.subId || '');
  const hasPendingBootstrap =
    Boolean(subscriptionId) && subscriptionId !== currentSubId;

  const flipperSubId = String(
    subscriptionContext.flipperContext?.subscription_id || ''
  );

  const canRenderResupplyModelV3 =
    Boolean(currentSubId) &&
    flipperSubId === currentSubId &&
    subscriptionContext.flipperContext?.release_resupply_model_v3 === true;

  if (hasPendingBootstrap || !canRenderResupplyModelV3) {
    return null;
  }

  return <>{children}</>;
};

ResupplyModelV3Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ResupplyModelV3Layout;
